import React, { useState, useEffect, useCallback } from 'react';
import { withAuth as withOktaAuth } from '@okta/okta-react';

import './GaiAuth.css';

// const environments = {
//   'staging-au': 'https://services.aws-platform-staging-au.iress.online',
//   'staging-ca': 'https://services.aws-platform-staging-ca.iress.online',
//   'staging-uk': 'https://services.aws-platform-staging-uk.iress.online',
//   'staging-za': 'https://services.aws-platform-staging-za.iress.online',
//   'uat-au': 'https://services-uat.iress.com.au',
//   'uat-ca': 'https://services-uat.iress.ca',
//   'uat-uk': 'https://services-uat.iress.co.uk',
//   'uat-za': 'https://services-uat.iress.co.za',
//   'production-au': 'https://services.iress.com.au',
//   'production-ca': 'https://services.iress.ca',
//   'production-uk': 'https://services.iress.co.uk',
//   'production-za': 'https://services.iress.co.za',
// };

const GAI_REQUEST_OPTS = {
  credentials: 'include',
  mode: 'cors',
  headers: { accept: 'application/json' },
};

const checkLoggedInState = async gaiUrl => {
  const userIdResponse = await fetch(`${gaiUrl}/.id`, GAI_REQUEST_OPTS);
  const data = await userIdResponse.json();
  if (userIdResponse.ok) {
    return data;
  } else {
    console.error(data);
    return null;
  }
};

const GaiAuth = ({ gaiUrl, auth: oktaAuth }) => {
  const [gaiUser, setGaiUser] = useState(null);

  const logIn = useCallback(async () => {
    const prevState = await checkLoggedInState(gaiUrl);
    setGaiUser(prevState);
    if (prevState) {
      // already logged in
      return;
    }

    const idToken = await oktaAuth.getIdToken();
    const sessionResponse = await fetch(`${gaiUrl}/.session`, {
      method: 'POST',
      ...GAI_REQUEST_OPTS,
      body: JSON.stringify({ type: 'Okta', token: idToken }),
    });
    if (sessionResponse.ok) {
      setGaiUser(await checkLoggedInState(gaiUrl));
    } else {
      setGaiUser(await sessionResponse.json());
    }
  }, [gaiUrl, oktaAuth]);

  const logOut = async () => {
    await fetch(`${gaiUrl}/.session`, {
      method: 'DELETE',
      credentials: 'include',
      mode: 'cors',
    });
    const newState = await checkLoggedInState(gaiUrl);
    setGaiUser(newState);
  };

  useEffect(() => {
    logIn();
  }, [gaiUrl, logIn]);

  return (
    <div className="GaiAuth">
      {gaiUser ? (
        <>
          {gaiUser.reason ? (
            <span>
              <span role="img" aria-label="Cross">
                ❌
              </span>{' '}
              GAI session failed.
            </span>
          ) : (
            <span>
              <span role="img" aria-label="Tick">
                ✅
              </span>{' '}
              GAI session established.
              <br />
              <button className="btn cancel GaiAuth-logout" onClick={logOut}>
                Delete Session
              </button>
            </span>
          )}
          <div className="GaiAuth-user">
            <h4>Claims</h4>
            {Object.entries(gaiUser).map(([key, value]) => (
              <code key={key}>
                {key}: {value}
                <br />
              </code>
            ))}
          </div>
        </>
      ) : (
        <span>
          <span role="img" aria-label="Warning">
            ⚠️
          </span>{' '}
          Not logged in to GAI.
        </span>
      )}
    </div>
  );
};

export default withOktaAuth(GaiAuth);
